module.exports = __webpack_public_path__ + "img/unlink.4eae3789.svg";